<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { writable } from "svelte/store";
  import Modal from "./Modal.svelte";
  import { HStack, VStack } from "../component/layout";
  import { Icon, Button, Label, Combobox } from "../component/widget";

  import {
    getLabels,
    load as loadAllLabels,
    loadGuest,
    loadInvitation,
    create,
    add,
    deleteLabel,
  } from "../labels.js";

  export let guestId;
  export let isGuest = true;

  let label = { id: null, name: null };
  let labels = writable([]);
  let all = [];
  let current = "label";

  const load = () => {
    (isGuest ? loadGuest(guestId) : loadInvitation(guestId))
      .then((r) => {
        labels.set(r);
      })
      .catch((e) => {
        labels.set([]);
      });
  };

  onMount(() => {
    load();
    getLabels().subscribe((labels) => {
      all = labels;
    });
  });

  const dispatch = createEventDispatcher();
  const close = async () => {
    dispatch("close");
  };

  const addLabel = async () => {
    try {
      let labelId = label.id;
      if (label.id == null && label.name) {
        let found = all.find((l) => l.name.toLocaleLowerCase() == label.name.toLocaleLowerCase());
        if (found) {
          labelId = found.id;
        } else {
          let res = await create(label.name);
          labelId = res.data.id;
        }
      }
      if (labelId) {
        await add(guestId, labelId, isGuest);
      }

      await load();
      await loadAllLabels();
      dispatch("refresh");
      close();
    } catch (e) {
      console.log(e);
    }
  };

  const deleteLabelForGuest = async (labelId) => {
    try {
      await deleteLabel(guestId, labelId, isGuest);
      await load();
      dispatch("refresh");
    } catch (e) {
      console.log(e);
    }
  };
</script>

<Modal on:close cancelButton={false}>
  <VStack>
    <div class="line">
      <span>Labels</span>
    </div>
    <Combobox
      id="label"
      reset
      bind:value={label}
      icon="fas fa-search"
      values={all}
      label="Search"
      placeholder="Nouveau label"
      margin={true}
      bind:current>
      <Button action={addLabel}>
        <Icon name="plus-square" size="38" />
      </Button>
    </Combobox>

    {#each $labels as l (l.id)}
      <HStack>
        <Label text={l.name} icon="tag" h="auto" />
        <Button action={() => deleteLabelForGuest(l.id)}>
          <Icon name="minus-square" />
        </Button>
      </HStack>
    {/each}
  </VStack>
</Modal>

<style>
  div.line {
    font-family: "Cinzel";
    border-bottom: 1px solid var(--secondary-light-color);
  }
</style>
